import React, { useEffect, useRef } from 'react';
import CommonModal from './CommonModal';
import ScanButton from '../ScanButton';

/**
 * Purely presentational - the actual voucher-code API call
 * (apiUrls.VOUCHER_VALIDITY) stays in CheckoutSummary.js's existing
 * handleApplyCoupon, unchanged; this just moves its input/button into a popup.
 */
const ApplyVoucherModal = ({ isOpen, onClose, coupon, onCouponChange, onApply, applying, message }) => {
  // A scanned voucher (ScanListener -> 'scan:voucher') is filled in and applied while this is open.
  const live = useRef({});
  live.current = { onCouponChange, onApply, applying };
  useEffect(() => {
    if (!isOpen) return undefined;
    const onScan = (e) => {
      const detail = e.detail || {};
      if (!detail.code) return;
      detail.handled = true;
      live.current.onCouponChange(detail.code);
      if (!live.current.applying) live.current.onApply(detail.code);
    };
    window.addEventListener('scan:voucher', onScan);
    return () => window.removeEventListener('scan:voucher', onScan);
  }, [isOpen]);

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} elId="applyVoucherModal">
      <div className="modal-header">
        <h1 className="modal-title mdTitle" id="applyVoucherModalLabel">Apply Voucher</h1>
        <button type="button" className="btn-close" onClick={onClose}></button>
      </div>

      <div className="modal-body">
        <div className="modalBodyStyle">
          <div className="mb-3">
            <label className="form-label">Voucher or Gift Card Code</label>
            <div className="d-flex align-items-center gap-2">
              <input
                type="text"
                className="form-control"
                placeholder="Enter code"
                value={coupon}
                onChange={(e) => onCouponChange(e.target.value)}
                disabled={applying}
                autoFocus
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !applying) {
                    e.preventDefault();
                    onApply();
                  }
                }}
              />
              <ScanButton />
            </div>
          </div>
          {message && <small className="text-primary d-block">{message}</small>}
        </div>
      </div>

      <div className="modal-footer justify-content-between">
        <button type="button" className="btn btnLight" onClick={onClose}>Close</button>
        <button type="button" className="btn btnPrimary" onClick={onApply} disabled={applying}>
          {applying ? 'Applying...' : 'Apply Voucher'}
        </button>
      </div>
    </CommonModal>
  );
};

export default ApplyVoucherModal;
